import { Button, Grid, Logo } from '@focaldata/cin-ui-components'
import { AppState, AppStateContext } from 'containers/State/AppState'
import React, { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useStyles from './LanguagePage.styles'

const getLanguageAutonym = (language: string): string => {
  try {
    // Intl.DisplayNames renders the autonym (language name in its own language)
    // when the display locale matches the language being named.
    const display = new Intl.DisplayNames([language], { type: 'language' })
    const name = display.of(language)
    if (name && name !== language) {
      // Capitalise the first letter so that languages like 'français' read as
      // 'Français' on the button.
      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  } catch {
    // Fall through to the raw code below
  }
  return language.toUpperCase()
}

const LanguagePage: React.FC = () => {
  const {
    surveyLocales: [surveyLocales],
    selectedLanguage: [, setSelectedLanguage]
  } = useContext<AppState>(AppStateContext)
  const navigate = useNavigate()
  const location = useLocation()
  const { classes } = useStyles()

  if (!surveyLocales) {
    return null
  }

  const handleSelect = (language: string) => {
    setSelectedLanguage(language)
    navigate({ pathname: '/info', search: location.search })
  }

  return (
    <Grid
      container
      alignItems="center"
      direction="column"
      justifyContent="center"
      className={classes.container}
    >
      <div className={classes.visual}>
        <Logo width={180} />
      </div>
      <nav className={classes.languageList} aria-label="Choose language">
        {surveyLocales.availableLanguages.map((language) => (
          <Button
            key={language}
            onClick={() => handleSelect(language)}
            className={classes.languageButton}
          >
            {/* lang lives on a wrapping span because the design-system Button
                only forwards a fixed allowlist of props — without this the
                screen reader would mis-pronounce autonyms like "Français". */}
            <span lang={language}>{getLanguageAutonym(language)}</span>
          </Button>
        ))}
      </nav>
    </Grid>
  )
}

export default LanguagePage
